import React, { FC } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { applyMiddleware, createStore, compose } from 'redux'
import thunk from 'redux-thunk'
import TagManager from 'react-gtm-module'
//import * as Sentry from '@sentry/browser'
import URLSearchParams from 'url-search-params'
import logger from 'redux-logger'

import plann3rStore from './store'

import Login from './containers/authentication/Login'
import Header from './Components/header/Header'
import CompanyApprove from './containers/others/CompanyApprove'
import Settings from './containers/settings/Settings'
import MyMeetings from './containers/meeting-management/overview/MyMeetings'
import OnboardingFlow from './containers/onboarding/OnboardingFlow'
import Integrations from './containers/integrations/Integration'
import { LandingPage } from './containers/landing-page'

import './styles/styles.scss'

import { createCookie, readCookie } from './utils/cookies'
import { Routes } from './routing/routes'
import Logout from './containers/authentication/Logout'
import Privacy from './containers/others/Privacy'
import Cookie from './containers/others/Cookie'
import Footer from './Components/footer/Footer'
import GuardedRoute from './routing/GuardedRoute'
import { setLanguage } from './store/languages/actions'
import MeetingDetails from './containers/meeting-management/details/MeetingDetails'
import MeetingPage from './containers/meeting-page/MeetingPage'
import PagesManagement from './containers/pages-management/PagesManagement'
import { GTM_ID } from './constants'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { settingsUpdateTimezone } from './store/settings/actions'


const App: FC = () => {
  // INIT SENTRY
  // if (process.env.NODE_ENV === 'production')
  //   Sentry.init({
  //     dsn: process.env.SENTY_DSN,
  //   })

  // INIT TAGMANAGER
  TagManager.initialize({
    gtmId: 'GTM-' + GTM_ID,
  })

  // SETUP STORE
  const store = createStore(
    plann3rStore,
    compose(applyMiddleware(thunk, logger)),
  )

  // SET LANGUAE BASED ON COOKIE, URL OR BROWSER
  let language = new URLSearchParams(window.location.search).get('language')
  if (language) {
    language = language.toUpperCase()

    if (language !== readCookie('language')) {
      createCookie('language', language, 60)
    }
  } else {
    if (readCookie('language')) {
      language = readCookie('language')
    } else {
      language = navigator.language.toUpperCase()
      if (language.length > 2) {
        language = language.substr(0, 2).toLowerCase()
      }
    }
  }
  if (language) store.dispatch(setLanguage(language))


  dayjs.extend(utc)
  dayjs.extend(timezone)
  const tz = dayjs.tz.guess()
  if(tz) store.dispatch(settingsUpdateTimezone(tz))


  // CHECK FOR AFFILIATE LINK
  const affiliate = new URLSearchParams(window.location.search).get('aff')
  if (affiliate) createCookie('affiliate', affiliate, 14)

  return (
    <Provider store={store}>
      <Router>
        <Header />
        <Route exact path={Routes.HOME} component={LandingPage} />
        <Route path={Routes.ONBOARDING} component={OnboardingFlow} />
        <GuardedRoute
          path={Routes.PAGES_MANAGEMENT}
          component={PagesManagement}
        />
        <Route path={Routes.MEETING_PAGE} component={MeetingPage} />
        <div className="app">
          <div className="styles">
            <GuardedRoute path={Routes.INTEGRATIONS} component={Integrations} />
            <Route path={Routes.PRIVACY} component={Privacy} />
            <Route path={Routes.COOKIES} component={Cookie} />
            <Route path={Routes.LOGIN} component={Login} />
            <GuardedRoute path={Routes.LOGOUT} component={Logout} />
            <GuardedRoute path={Routes.SETTINGS} component={Settings} />
            <Route path={Routes.COMPANY_APPROVE} component={CompanyApprove} />
            <Switch>
              <GuardedRoute
                path={Routes.MY_MEETINGS_DETAIL}
                component={MeetingDetails}
              />
              <GuardedRoute path={Routes.MY_MEETINGS} component={MyMeetings} />
            </Switch>
          </div>
        </div>
        <Footer />
      </Router>
    </Provider>
  )
}

export default App
